import {DatabaseCode, toDatabaseCode} from "./database-code";

export type TransportMethod = DatabaseCode

const trucking: TransportMethod = {
  code: 'TRUCKING',
  displayValue: {
    id: 'common.entity.transport.method.trukcing',
    defaultMessage: 'Trucking',
  },
};

const pipeline: TransportMethod = {
  code: 'PIPELINE',
  displayValue: {
    id: 'common.entity.transport.method.pipeline',
    defaultMessage: 'Pipeline',
  },
};

export const transportMethod = {
  trucking,
  pipeline,
};

export const transportMethods = Object.values(transportMethod);

export const toTransportMethod = (code: string): TransportMethod => toDatabaseCode(code, transportMethods);
